// Shared inline styles for the super-admin login sub-screens (2FA prompt, first-login setup,
// enable-2FA panel). Matches the palette of the main login page (indigo/purple).
export const ui = {
  card: { width: '100%', maxWidth: '420px', alignSelf: 'center', display: 'flex', flexDirection: 'column' },
  heading: { fontSize: '26px', fontWeight: 800, color: '#0F172A', margin: '0 0 6px', letterSpacing: '-0.5px', lineHeight: 1.2 },
  sub: { fontSize: '14px', color: '#64748B', margin: '0 0 20px', lineHeight: 1.6 },
  field: { display: 'flex', flexDirection: 'column', marginBottom: '16px' },
  label: { fontSize: '13px', fontWeight: 600, color: '#334155', marginBottom: '7px' },
  input: {
    width: '100%', padding: '14px 16px', fontSize: '15px', color: '#0F172A',
    backgroundColor: '#ffffff', border: '1.5px solid rgba(203,213,225,0.9)',
    borderRadius: '12px', outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit',
  },
  codeInput: { letterSpacing: '0.4em', textAlign: 'center', fontSize: '22px', fontWeight: 700, paddingLeft: '0.4em' },
  inputErr: { borderColor: '#F87171', backgroundColor: '#FFF1F2' },
  ferr: { fontSize: '12px', color: '#EF4444', marginTop: '5px' },
  cta: {
    width: '100%', padding: '14px', fontSize: '15px', fontWeight: 700, color: '#ffffff',
    background: 'linear-gradient(135deg,#0A9188 0%,#0FA89B 100%)', border: 'none',
    borderRadius: '12px', cursor: 'pointer', fontFamily: 'inherit', marginTop: '4px',
  },
  ctaDisabled: { opacity: 0.6, cursor: 'not-allowed' },
  secondaryBtn: {
    width: '100%', padding: '12px', fontSize: '14px', fontWeight: 600, color: '#0A9188',
    background: 'transparent', border: '1.5px solid rgba(79,70,229,0.3)', borderRadius: '12px',
    cursor: 'pointer', fontFamily: 'inherit', marginTop: '10px',
  },
  linkBtn: { background: 'none', border: 'none', color: '#0FA89B', fontWeight: 600, fontSize: '13px', cursor: 'pointer', padding: 0, fontFamily: 'inherit' },
  errBanner: {
    display: 'flex', alignItems: 'center', gap: '8px', backgroundColor: '#FEF2F2',
    border: '1px solid #FCA5A5', color: '#DC2626', borderRadius: '10px',
    padding: '11px 14px', fontSize: '13px', marginBottom: '16px',
  },
  okBanner: {
    display: 'flex', alignItems: 'center', gap: '8px', backgroundColor: '#F0FDF4',
    border: '1px solid #86EFAC', color: '#15803D', borderRadius: '10px',
    padding: '11px 14px', fontSize: '13px', marginBottom: '16px',
  },
  secretBox: {
    fontFamily: 'monospace', fontSize: '14px', wordBreak: 'break-all', background: '#F8FAFC',
    border: '1px solid #E2E8F0', borderRadius: '10px', padding: '12px 14px', color: '#0F172A', userSelect: 'all',
  },
  eyeBtn: { position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'flex' },
};
